import React from 'react';
import './SymbolTileValues.scss';
import * as tooltips from './help/symbolTileValuesTooltips';
import Tooltip from 'utils/components/Tooltip/Tooltip';
import { SymbolTileData } from 'widgets/symbolTile/components/symbolTileData';

export interface SymbolTileValuesProps {
    data: SymbolTileData;
}

export function SymbolTileValues(props: SymbolTileValuesProps) {
    const { data } = props;
    const { price, pnc, bid, ask, high, low } = data.formattedValues;

    return (
        <div className="SymbolTileValues capsule-values flippable">
            <div>
                <div className="label">
                    <Tooltip text={tooltips.lastTradePrice}>Price</Tooltip>
                </div>
                <div className="value price-value">{price}</div>
                <div className="label">
                    <Tooltip text={tooltips.pnc}>PNC</Tooltip>
                </div>
                <div className="value pnc-value">{pnc}</div>
            </div>
            <div>
                <div className="label">Bid</div>
                <div className="value">{bid}</div>
                <div className="label">High</div>
                <div className="value">{high}</div>
            </div>
            <div>
                <div className="label">Ask</div>
                <div className="value">{ask}</div>
                <div className="label">Low</div>
                <div className="value">{low}</div>
            </div>
        </div>
    );
}
